(() => {
  const form = document.getElementById('HHRRentalRequest');
  if (!form || form.dataset.intakeBound) return;
  form.dataset.intakeBound = 'true';
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('[data-intake-status]');
  const japanese = document.documentElement.lang.toLowerCase().startsWith('ja');
  const text = japanese ? {
    sending: '送信しています…',
    received: '申請を受け付けました。受付番号：',
    followup: 'ご契約内容を確認後、担当者よりメールでご案内します。この時点では解約・プラン変更は完了していません。',
    failed: '受付を確認できませんでした。入力内容は保持されています。再度送信するか、下記の窓口へお問い合わせください。',
    limited: '送信が集中しています。1分ほど待ってから、同じ内容で再度お試しください。',
    conflict: '送信内容を確認できませんでした。下記の窓口へお問い合わせください。',
  } : {
    sending: 'Submitting…', received: 'Request received. Reference: ',
    followup: 'Our team will verify your subscription and contact you by email. Cancellation or plan changes are not completed by this submission.',
    failed: 'We could not confirm receipt. Your entries are preserved. Please retry or contact support below.',
    limited: 'Too many attempts. Please wait a minute and retry with the same details.',
    conflict: 'We could not confirm the submitted details. Please contact support below.',
  };
  const editPanel = form.querySelector('[data-intake-edit]');
  const reviewPanel = form.querySelector('[data-intake-review]');
  const summary = form.querySelector('[data-intake-summary]');
  const backButton = form.querySelector('[data-intake-back]');
  const nextSteps = form.querySelector('[data-intake-next]');
  const confirmEmail = form.querySelector('[name="contact[email_confirmation]"]');
  let reviewing = false;
  function step(name) {
    document.querySelectorAll('[data-intake-step]').forEach(item => {
      if (item.dataset.intakeStep === name) item.setAttribute('aria-current', 'step');
      else item.removeAttribute('aria-current');
    });
  }
  function review() {
    summary.replaceChildren();
    for (const control of form.querySelectorAll('[data-intake-edit] input, [data-intake-edit] select, [data-intake-edit] textarea')) {
      if (!control.name?.startsWith('contact[') || control.type === 'hidden' || control.name === 'contact[email_confirmation]' || control.id === 'hhr-request-type' || (['checkbox', 'radio'].includes(control.type) && !control.checked)) continue;
      const label = control.labels?.[0];
      const title = (control.type === 'radio' ? control.closest('fieldset')?.querySelector('legend')?.textContent : '') || label?.childNodes?.[0]?.textContent?.trim() || label?.textContent?.trim() || control.name;
      const value = control.tagName === 'SELECT' ? (control.value ? control.selectedOptions[0].textContent : '—') : control.type === 'checkbox' ? (japanese ? '確認済み' : 'Confirmed') : control.type === 'radio' ? label.textContent.trim() : control.value || '—';
      const row = document.createElement('div');
      const term = document.createElement('dt'); term.textContent = title;
      const detail = document.createElement('dd'); detail.textContent = value;
      row.append(term, detail); summary.append(row);
    }
    reviewing = true; editPanel.hidden = true; reviewPanel.hidden = false;
    status.hidden = true; backButton.hidden = false; button.textContent = button.dataset.sendLabel;
    step('review'); reviewPanel.querySelector('h2').focus();
  }
  backButton?.addEventListener('click', () => {
    if (busy || completed) return;
    reviewing = false; editPanel.hidden = false; reviewPanel.hidden = true;
    backButton.hidden = true; button.textContent = button.dataset.reviewLabel; status.hidden = true;
    step('input'); editPanel.querySelector('input:not([type="hidden"]):not([type="radio"])')?.focus();
  });
  confirmEmail?.addEventListener('input', () => confirmEmail.setCustomValidity(''));
  form.querySelector('[name="contact[email]"]')?.addEventListener('input', () => confirmEmail?.setCustomValidity(''));
  let pending = null;
  let busy = false;
  let completed = false;
  const storageKey = 'hhr-intake-pending-v1';
  function show(message, error = false) {
    status.hidden = false;
    status.textContent = message;
    status.className = error ? 'request-errors' : 'request-success';
  }
  const get = name => String(new FormData(form).get(name) || '').trim();
  async function fingerprint(payload) {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(payload)));
    return Array.from(new Uint8Array(digest), x => x.toString(16).padStart(2, '0')).join('');
  }
  button.disabled = false;
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || completed) return;
    if (confirmEmail) confirmEmail.setCustomValidity(get('contact[email_confirmation]') === get('contact[email]') ? '' : (japanese ? 'メールアドレスが一致しません。入力内容をご確認ください。' : 'Email addresses do not match. Please check both fields.'));
    if (!form.reportValidity()) return;
    if (reviewPanel && !reviewing) { review(); return; }
    busy = true;
    button.disabled = true;
    if (backButton) backButton.disabled = true;
    form.setAttribute('aria-busy', 'true');
    show(text.sending);
    let timeout;
    try {
      const payload = {
        requestType: form.querySelector('#hhr-request-type').selectedOptions[0].dataset.kind,
        name: get('contact[name]'), email: get('contact[email]'),
        orderReference: get('contact[order_or_subscription]'),
        reason: [get('contact[cancel_reason]'), get('contact[body]')].filter(Boolean).join(': ').slice(0, 2000),
        note: [get('contact[body]'), ...[
          ['store', 'Store'], ['cancellation_product', 'Product'], ['phone', 'Phone'],
          ['age_range', 'Age range'], ['cat_count', 'Cats'], ['days_to_use', 'Days until use'],
          ['cancel_reason', 'Reason'], ['device_count', 'Devices'], ['return_carrier', 'Carrier'],
          ['clean', 'Cleaning commitment'], ['pack', 'Packing commitment'], ['parts', 'Accessories commitment'],
        ].map(([field, label]) => get(`contact[${field}]`) ? `${label}: ${get(`contact[${field}]`)}` : '')].filter(Boolean).join('\n'),
        serialNumber: get('contact[device_serial]'),
        returnTracking: get('contact[return_tracking]'),
        requestedPlan: get('contact[requested_plan]'),
        termsAccepted: form.querySelector('[name="contact[acknowledgment]"]').checked,
        website: get('website'),
      };
      const hash = await fingerprint(payload);
      if (!pending) {
        try { pending = JSON.parse(sessionStorage.getItem(storageKey)); } catch { /* Storage may be blocked. */ }
      }
      if (!pending || pending.hash !== hash || !/^[0-9a-f-]{36}$/i.test(pending.id || '')) {
        pending = { hash, id: crypto.randomUUID() };
      }
      // Persist only a hash and random id, never contact details or free text.
      try { sessionStorage.setItem(storageKey, JSON.stringify(pending)); } catch { /* In-memory retries still work. */ }
      const controller = new AbortController();
      timeout = setTimeout(() => controller.abort(), 20000);
      const response = await fetch(form.dataset.intakeEndpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'omit', signal: controller.signal,
        body: JSON.stringify({ ...payload, requestId: pending.id }),
      });
      const result = await response.json();
      if (!response.ok || !result.ok || result.receipt !== `HHR-${pending.id}` || !Number.isFinite(Date.parse(result.receivedAt))) {
        const message = response.status === 429 ? text.limited : response.status === 409 ? text.conflict : text.failed;
        throw new Error(message);
      }
      completed = true;
      if (reviewPanel) { reviewPanel.hidden = true; editPanel.hidden = true; backButton.hidden = true; button.hidden = true; nextSteps.hidden = false; step('done'); }
      show(`${text.received}${result.receipt}\n${text.followup}`);
      status.style.whiteSpace = 'pre-line';
      form.querySelectorAll('input, select, textarea').forEach(control => { control.disabled = true; });
      try { sessionStorage.removeItem(storageKey); } catch { /* No personal data was stored. */ }
      status.focus();
    } catch (error) {
      const message = [text.limited, text.conflict].includes(error.message) ? error.message : text.failed;
      show(message, true);
      status.focus();
    } finally {
      clearTimeout(timeout);
      busy = false;
      button.disabled = completed;
      if (backButton) backButton.disabled = completed;
      form.removeAttribute('aria-busy');
    }
  });
})();
